import { defineStore } from "pinia";

export const useLanguageStatusStore = defineStore('LanguageStatus', {
    state: () => ({
        show: false
    })
});